import {FC} from 'react'
import { getStyledDealsCard } from '../../styled-components/DealsSection.styled'
const dealsIcon = require('../../util/icons/dealsicon.png')

export interface DealsCardProps {
    title: string
}

export const DealsCard: FC<DealsCardProps> = ({title}) => {

    const CardWrapper = getStyledDealsCard()

    return(
        <CardWrapper>
            <img src={dealsIcon} alt="deals icon" />
            <span className="card-title">{title}</span>
            <p className='card-description'>Online shoppinasdasdg for retail sales direct to consumers</p>
        </CardWrapper>
    )
}